import stripGetters from './stripGetters';

type ModelFactory<T> = () => T;
type StateFactory<T> = (prevState: Partial<T>, nextState?: Partial<T>) => T;

const createStateFactory: <T extends {}>(modelFactory: ModelFactory<T>) => StateFactory<T> =
    modelFactory => (prevState, nextState?) => {
        const model = modelFactory();

        return Object.assign(model, stripGetters(prevState, model), nextState);
    };

export default createStateFactory;
